/* eslint-disable react-hooks/exhaustive-deps */
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import {
  fetchActivitiesList,
  fetchDmaLocations,
  fetchKeyPlantsDetails,
  fetchVehicles,
} from "../fetchData";
import { MultiSelect } from "primereact/multiselect";

const SelectDropDowns = ({
  toast,
  isUploadInProgress,
  formValues,
  setFormValues,
}: any) => {
  const [vehicleListLoading, setVehicleListLoading] = useState<boolean>(false);
  const [vehiclesList, setVehiclesList] = useState([]);
  const [dmaLocationsList, setDmaLocationsList] = useState<any>([]);
  const [dmaLocationsListLoading, setDmaLocationsListLoading] =
    useState<boolean>(false);
  const [keyPlantsDetailsList, setKeyPlantsDetailsList] = useState<any>([]);
  const [keyPlantsListLoading, setKeyPlantsListLoading] =
    useState<boolean>(false);
  const [activitiesList, setActivitiesList] = useState<any>([]);
  const [activitiesListLoading, setActivitiesListLoading] =
    useState<boolean>(false);

  useEffect(() => {
    fetchVehicles(setVehiclesList, setVehicleListLoading, toast);
    fetchDmaLocations(setDmaLocationsList, setDmaLocationsListLoading, toast);
    fetchKeyPlantsDetails(
      setKeyPlantsDetailsList,
      setKeyPlantsListLoading,
      toast
    );
    fetchActivitiesList(setActivitiesList, setActivitiesListLoading, toast);
  }, []);

  return (
    <div>
      <div className="tw-flex tw-justify-stretch tw-gap-5 tw-items-center tw-flex-wrap tw-mt-5">
        <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full md:tw-w-fit">
          <label className="leak-label" htmlFor="teamMember1">
            {" "}
            DMA/Location
          </label>
          <Dropdown
            id="teamMember1"
            optionLabel="name"
            placeholder="Select DMA/Location"
            disabled={isUploadInProgress}
            value={formValues?.dma_location ?? ""}
            loading={dmaLocationsListLoading}
            onChange={(e) => {
              setFormValues((prev: any) => ({
                ...prev,
                dma_location: e.value,
              }));
            }}
            options={dmaLocationsList}
            filter
            className="custome-dropdown"
          />
        </div>
        <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full md:tw-w-fit">
          <label htmlFor="teamnMember2 " className="leak-label">
            {" "}
            Vehicle Registration
          </label>
          <Dropdown
            id="teamnMember2"
            options={vehiclesList}
            disabled={isUploadInProgress}
            loading={vehicleListLoading}
            optionLabel="registration_no"
            placeholder="Select Vehicle"
            value={formValues?.vehicleRegistration ?? ""}
            onChange={(e) => {
              setFormValues((prev: any) => ({
                ...prev,
                vehicleRegistration: e.value,
              }));
            }}
            filter
            className="custome-dropdown"
          />
        </div>
        <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full md:tw-w-fit ">
          <label htmlFor="addteamname" className="leak-label">
            {" "}
            Key Plant Details
          </label>
          <MultiSelect
            id="addteamname"
            selectAllLabel="Select All"
            maxSelectedLabels={2}
            placeholder="Select Key Plant"
            optionLabel="name"
            disabled={isUploadInProgress}
            value={formValues?.keyPlantDetails ?? ""}
            loading={keyPlantsListLoading}
            onChange={(e) => {
              setFormValues((prev: any) => ({
                ...prev,
                keyPlantDetails: e.value,
              }));
            }}
            filter
            options={keyPlantsDetailsList}
            className="custome-dropdown"
          />
        </div>
        <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full md:tw-w-fit">
          <label htmlFor="addteamname" className="leak-label">
            Activity
          </label>
          <Dropdown
            id="addteamname"
            placeholder="Select Activity"
            optionLabel="name"
            disabled={isUploadInProgress}
            value={formValues?.activity ?? ""}
            loading={activitiesListLoading}
            onChange={(e) => {
              setFormValues((prev: any) => ({
                ...prev,
                activity: e.value,
              }));
            }}
            filter
            options={activitiesList}
            className="custome-dropdown"
          />
        </div>
      </div>
    </div>
  );
};

export default SelectDropDowns;
